// extracted by css-extract-rspack-plugin
export default {"token":"Ns3IFQ"};